module.exports = __webpack_public_path__ + "img/bp_lp_button_shien.dd8dc207.png";